import React from "react";
import "./Landing_page.css";
import bg from "../Assets/landig_bg.png";

export default function Landing_page() {
  return (
    <div className="main_landing_page" id="About">
      <div className="container position-relative landing_pics">
      {/* Elegant wing-inspired decorative elements */}
      <div className="wing-decoration wing-top-left d-none d-lg-block"></div>
      <div className="wing-decoration wing-bottom-left d-none d-lg-block"></div>
      <div className="wing-decoration wing-top-right d-none d-lg-block"></div>
      <div className="wing-decoration wing-bottom-right d-none d-lg-block"></div>
        <div className="position-relative">
          <img src={bg} className="landing_clr_bg d-none d-lg-block" alt="" />
          <div className="landing_text">
            <h1 className="wll_com">Welcome to </h1>
            {/* <h1 className="marvel_coin mt-3 text-uppercase text-white">Falco P</h1> */}
            <h1
              className="marvel_coin universer_text text-uppercase"
              style={{ color: "#F6D166" }}
            >
              Falco P
            </h1>
            <div className="athletic-tagline mt-3">
              <p className="tagline-text">REVOLUTIONIZING THE FASHION LANDSCAPE</p>
              <p className="tagline-subtext">Guided by the spirit of the falcon</p>
            </div>
          </div>
          <div className="row justify-content-center">
          <div className="col-md-10">
          <p className="landing_para robo_font">
            You are not just buying a shoe. You are buying a piece of a dream. 
            The Falco P - where athletic performance meets aerodynamic artistry. 
            Stop moving through the world. Start owning it.
          </p>
          </div>
          </div>
          
          <div className="d-flex justify-content-center mt-3">
            <button className="mint_nft_butn robo_font">Mint NFT</button>
          </div>
        </div>

      </div>
    </div>
  );
}
